<script setup lang="ts">
import { inject } from 'vue'
import PlayIcon from './svg/PlayIcon.vue'
import PauseIcon from './svg/PauseIcon.vue'
import QuarterCircle from './svg/QuarterCircle.vue'
import { autoPlayKey } from '@/constant/symbol'

interface Emits {
  (e: 'onPauseAutoPlay'): void
  (e: 'onStartAutoPlay'): void
}

const emits = defineEmits<Emits>()

const autoplay = inject(autoPlayKey)
</script>

<template>
  <div class="flex pl-2 gap-2 bg w-fit rd-full items-center">
    <p>
      {{ autoplay ? "Playing" : "Paused" }}
    </p>
    <div
      class="relative bg-#fff rd-full w-7 h-7 flex justify-center items-center"
      @pointerdown="(e) => {
        e.preventDefault();
        e.stopPropagation();
        //toggle autoplay
        if (autoplay) {
          autoplay = false;
          emits('onPauseAutoPlay')
          return;
        }
        autoplay = true;
        emits('onStartAutoPlay')
      }"
    >
      <quarter-circle
        v-show="autoplay"
        class="absolute w-full h-full rotater"
      />
      <play-icon
        v-if="!autoplay"
        class="w-4 h-4"
        fill="#32323D"
      />
      <pause-icon
        v-if="autoplay"
        fill="#32323D"
        class="w-4 h-4"
      />
    </div>
  </div>
</template>

<style scoped>
.bg {
  background-color: rgba(0, 0, 0, 0.16);
}

/* rotate keyframe */
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rotater {
  animation: rotate 2s linear infinite;
}
</style>
